export default __webpack_public_path__ + "static/media/person_black_24dp.2c8715f3.svg";